import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { RView1jxdnn5qf89cm as RView } from '../RView.commonHtml.mjs';
import { ClickableSemantic_getInstance2dwzbc0ganf8f as ClickableSemantic_getInstance } from '../../models/Theme.mjs';
import { vpropka48um9uweps as vprop } from './helpers.commonHtml.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function RadioButton$checked$lambda($this$vprop) {
  // Inline function 'com.lightningkite.kiteui.views.checked' call
  var tmp = $this$vprop.bb4_1.kb7_1.checked;
  return ((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true;
}
function RadioButton$checked$lambda_0($this$vprop, value) {
  // Inline function 'com.lightningkite.kiteui.views.checked' call
  $this$vprop.bb4_1.kb7_1.checked = value;
  return Unit_instance;
}
var RadioButtonClass;
function RadioButton() {
  if (RadioButtonClass === VOID) {
    class $ extends RView() {
      constructor(context) {
        super(context);
        this.lba(this.qb6_1.abf(ClickableSemantic_getInstance()));
        this.vb5_1.zb3_1 = 'input';
        // Inline function 'com.lightningkite.kiteui.views.type' call
        this.vb5_1.bb4_1.kb7_1.type = 'radio';
        this.vb5_1.jb4_1.v('radio');
        this.vb5_1.jb4_1.v('checkResponsive');
        this.vb5_1.jb4_1.v('clickable');
        var tmp = this;
        var tmp_0 = this.vb5_1;
        var tmp_1 = RadioButton$checked$lambda;
        tmp.pc7_1 = vprop(tmp_0, 'input', tmp_1, RadioButton$checked$lambda_0);
      }
    }
    initMetadataForClass($, 'RadioButton');
    RadioButtonClass = $;
  }
  return RadioButtonClass;
}
//region block: exports
export {
  RadioButton as RadioButton1rpamcjl5aybg,
};
//endregion

//# sourceMappingURL=RadioButton.commonHtml.mjs.map
